import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Radio } from 'next-common-lib';
import i18n from 'i18n';
import { HOME_CONFIG_MENU_LABLE } from 'constants/wizardConstants';
import * as homeActions from 'redux/ducks/Home/HomeDucks';

export const SelectHome = () => {
  const dispatch = useDispatch();
  const selectedScreen = useSelector(state => state.home.screen);

  const handleOnClick = item => {
    dispatch(homeActions.updateHomeScreen({ item }));
  };

  const imgContents = (idx, txt) => {
    return (
      <>
        <div className="sub-text">{txt}</div>
        <div className="grid-box-wrap">
          <div className="grid-box">
            <span className={`home_${idx}`} />
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <div className="page-setting">
        <Radio
          checked={selectedScreen === 'ML'}
          id="ML"
          componentType="normal"
          label={i18n.t(HOME_CONFIG_MENU_LABLE.ML)}
          name="targetRaioBtn"
          tooltipInfo={{
            title: `${i18n.t(HOME_CONFIG_MENU_LABLE.ML)}`,
          }}
          onClick={() => {
            handleOnClick('ML');
          }}
        />
        {imgContents(2, i18n.t('PT_USER_CONFIG_INBOX_INFO'))}
      </div>
      <div className="page-setting">
        <Radio
          checked={selectedScreen === 'PT'}
          id="PT"
          componentType="normal"
          label={i18n.t(HOME_CONFIG_MENU_LABLE.PT)}
          value="PT"
          name="targetRaioBtn"
          tooltipInfo={{
            title: `${i18n.t(HOME_CONFIG_MENU_LABLE.PT)}`,
          }}
          onClick={() => {
            handleOnClick('PT');
          }}
        />
        {imgContents(1, i18n.t('PT_USER_CONFIG_DEFAULT_HOME_INFO'))}
      </div>
    </>
  );
};

SelectHome.propTypes = {};
SelectHome.defaultProps = {};
export default SelectHome;
